<template>
	<div class="booking bg-white">
		<div class="bg-white d-none d-md-flex steps-wizard mb-5">
			<div
				class="step-wizard"
				:key="name"
				@click="setStep(i)"
				:class="{ active: booking.step == i }"
				v-for="(name, i) in steps"
			>
				<div class="step-circle">
					<span></span>
				</div>

				<div class="step-name">
					{{ name }}
				</div>
			</div>
			<!-- /.step-wizard -->
		</div>
		<!-- /.steps-wizard -->

		<div class="row">
			<div class="col-md-12">
				<transition-group name="slide-fade">
					<booking-services
						key="services"
						ref="step-0"
						@closed="$emit('closed')"
						v-show="booking.step == 0"
					/>

					<booking-informations
						key="informations"
						ref="step-1"
						v-show="booking.step == 1"
					/>

					<booking-documents
						key="documents"
						ref="step-2"
						v-show="booking.step == 2"
					/>

					<booking-resume
						key="resume"
						ref="step-3"
						v-show="booking.step == 3"
					/>
				</transition-group>
			</div>
			<!-- /.col -->
		</div>
		<!-- /.row -->
	</div>
	<!-- /.booking -->
</template>

<script>
	import { mapState, mapGetters } from "vuex"
	import BookingServices from "@components/booking/steps/Services"
	import BookingInformations from "@components/booking/steps/Informations"
	import BookingDocuments from "@components/booking/steps/Documents"
	import BookingResume from "@components/booking/steps/Resume"

	export default {
		data() {
			return {
				steps: [
					this.$t("account/bookings.Services"),
					this.$t("account/bookings.Informations"),
					this.$t("account/bookings.Documents"),
					this.$t("account/bookings.Resume"),
				],
			}
		},

		props: {
			data: {
				type: Object,
				default: () => ({}),
			},
		},

		components: {
			BookingServices,
			BookingInformations,
			BookingDocuments,
			BookingResume,
		},

		computed: {
			...mapState({
				booking: state => state.booking,
			}),
		},

		methods: {
			setStep(index) {
				var current = this.booking.step

				if (index > current) {
					if (!this.$refs["step-" + this.booking.step].checkComplete()) {
						return false
					}
				}

				this.$store.commit("booking/setStep", index)
			},
		},
	}
</script>
